/* eslint-disable import/prefer-default-export */
import { GetAllRequest } from "apis/api-types";
import apiSlice from "apis/apiSlice";
import END_POINTS from "consts/endPoints";
import { IDataPopularTopic } from "resources/userSide/home";

interface GetAllPopularTopicRequest extends GetAllRequest {}
interface PopularTopicResponse extends Record<string, unknown> {
  items: IDataPopularTopic[];
  totalCount: number;
}
export interface GetSearchRequest extends GetAllRequest {}

interface SearchResponse extends Record<string, unknown> {
  id: string;
  title: string;
  content: string;
  slugUrl: string;
}
interface SearchResponseModal extends Record<string, unknown> {
  pageIndex: string | number;
  pageSize: string | number;
  totalCount: string | number;
  orderColumn: string;
  orderDirection: string;
  items?: Array<SearchResponse>;
}
const USERS = "USERS";
const CategoryUserSide = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    getCategoryUserSide: build.query({
      query: (params) => ({
        url: "api/UserSide/GetAllCategories",
        method: "get",
        params,
      }),
    }),
    getSubCategoryUserSide: build.query({
      query: (params) => ({
        url: "api/UserSide/GetAllSubCategoriesByParentId",
        method: "get",
        params,
      }),
    }),
    getArticleDetail: build.query({
      query: (params) => ({
        url: "api/UserSide/GetArticlePublishedDetail",
        method: "get",
        params,
      }),
    }),
    getPopularTopic: build.query<
      PopularTopicResponse,
      GetAllPopularTopicRequest | void
    >({
      query: (params) => ({
        url: "api/UserSide/GetPopularArticles",
        method: "get",
        params,
      }),
    }),
    getSearchBar: build.query<SearchResponseModal, GetSearchRequest | void>({
      query: (params) => ({
        url: END_POINTS.GET_TITLE_AND_CONTENT,
        method: "get",
        params,
      }),
    }),
    getSearchTitle: build.query<SearchResponseModal, GetSearchRequest | void>({
      query: (params) => ({
        url: END_POINTS.GET_TITLE,
        method: "get",
        params,
      }),
    }),
    countSearch: build.mutation<any, any>({
      query: (data) => ({
        url: END_POINTS.COUNT_SEARCH,
        method: "post",
        data,
      }),
    }),
    getArticleById: build.query<any, any>({
      query: (params) => ({
        url: `api/Article/GetArticle`,
        method: "get",
        params,
      }),
    }),
    getArticleBySlugUrl: build.query<any, any>({
      query: (params) => ({
        url: END_POINTS.GET_ARTICLE_BY_SLUG_URL,
        method: "get",
        params,
      }),
    }),
    getArticlePuslishedBySlugUrl: build.query<any, any>({
      query: (params) => ({
        url: END_POINTS.GET_ARTICLE_PUBLISHED_BY_SLUG_URL,
        method: "get",
        params,
      }),
    }),
    getSubCategoryUserSideSlugUrl: build.query({
      query: (params) => ({
        url: "api/UserSide/GetAllSubCategoriesByParentSlugUrl",
        method: "get",
        params,
      }),
    }),
    updateAllSortOrderArticle: build.mutation<any, any>({
      query: (params) => ({
        url: END_POINTS.UPDATE_ALL_SORT_ORDER_ARTICLE,
        method: "post",
        params,
      }),
    }),
    updateSortOrderArticle: build.mutation<any, any>({
      query: (params) => ({
        url: END_POINTS.UPDATE_SORT_ORDER_ARTICLE,
        method: "post",
        params,
      }),
    }),
  }),
});

export const {
  useGetCategoryUserSideQuery,
  useGetSubCategoryUserSideQuery,
  useLazyGetPopularTopicQuery,
  useLazyGetArticleDetailQuery,
  useGetSearchBarQuery,
  useLazyGetSearchBarQuery,
  useLazyGetSearchTitleQuery,
  useCountSearchMutation,
  useLazyGetArticleByIdQuery,
  useLazyGetArticleBySlugUrlQuery,
  useLazyGetArticlePuslishedBySlugUrlQuery,
  useGetSubCategoryUserSideSlugUrlQuery,
  useUpdateAllSortOrderArticleMutation,
  useUpdateSortOrderArticleMutation,
} = CategoryUserSide;
